/** One fixed, click-through overlay above the app for coins, flashes and the particle canvas. */
let layer: HTMLDivElement | null = null;

export function getLayer(): HTMLDivElement {
  if (layer && layer.isConnected) return layer;
  layer = document.createElement('div');
  layer.dataset.fxLayer = '';
  layer.setAttribute('aria-hidden', 'true');
  layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden;';
  document.body.appendChild(layer);
  return layer;
}

export function clearLayer(): void {
  if (!layer) return;
  for (const el of Array.from(layer.querySelectorAll('[data-fx-coin],[data-fx-flash]'))) el.remove();
}

export function rectCenter(el: Element): { x: number; y: number; r: DOMRect } {
  const r = el.getBoundingClientRect();
  return { x: r.left + r.width / 2, y: r.top + r.height / 2, r };
}
